module.exports = __webpack_public_path__ + "img/antes_despues_40.1c2a8dd1.png";